import { createAction, props } from '@ngrx/store';
import type { AufgabeResource } from 'libs/aufgabe-shared/src/lib/aufgabe.model';
import { KorrespondenzVorlage, KorrespondenzVorlageResource } from './korrespondenz-vorlage.model';

const PREFIX = '[Korrespondenz Vorlage] ';

export const loadKorrespondenzVorlageAction = createAction(
	PREFIX + 'Load Korrespondenz Vorlage',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const loadKorrespondenzVorlageSuccessAction = createAction(
	PREFIX + 'Load Korrespondenz Vorlage Success',
	props<{
		korrespondenzVorlage: KorrespondenzVorlageResource;
	}>()
);

export const createKorrespondenzVorlageAction = createAction(
	PREFIX + 'Create Korrespondenz Vorlage',
	props<{
		korrespondenzVorlage: KorrespondenzVorlage;
		vorlageId: number;
	}>()
);

export const createKorrespondenzVorlageSuccessAction = createAction(PREFIX + 'Create Korrespondenz Vorlage Success');

export const downloadKorrespondenzVorlageAction = createAction(PREFIX + 'Download Korrespondenz Vorlage');

export const askToDeleteKorrespondenzVorlageAction = createAction(
	PREFIX + 'Ask To Delete Korrespondenz Vorlage',
	props<{
		korrespondenzVorlage: KorrespondenzVorlageResource;
	}>()
);

export const deleteKorrespondenzVorlageAction = createAction(
	PREFIX + 'Delete Korrespondenz Vorlage',
	props<{
		korrespondenzVorlage: KorrespondenzVorlageResource;
	}>()
);

export const deleteKorrespondenzVorlageSuccessAction = createAction(
	PREFIX + 'Delete Korrespondenz Success',
	props<{
		korrespondenzVorlage: KorrespondenzVorlageResource;
	}>()
);
